export default __webpack_public_path__ + "static/media/new-ins.1578019a.svg";